import { render, staticRenderFns } from "./ToShopSelector.vue?vue&type=template&id=003fa294&scoped=true"
import script from "./ToShopSelector.vue?vue&type=script&lang=js"
export * from "./ToShopSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003fa294",
  null
  
)

export default component.exports